import React, { useMemo, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

//RETURN VALUE OBJECT BY INPUTNAME FROM FORMVALUES OBJECT
function getInputValues(inputName, formValuesArr) {
  if (formValuesArr) {
    const inputObject = formValuesArr.find((item) => {
      const key = Object.keys(item)[0];
      return key === inputName;
    });
    return inputObject ? inputObject[Object.keys(inputObject)[0] || 0] : {};
  }
}

const EntryContentRenderer = (props) => {
  const { businessName, contentId, paraTextContent, imageItems, formValData, allContent } = props;
  const [modifiedContent, setModifiedContent] = useState({
    nodeType: 'document',
    data: {},
    content: [],
  });

  //LOGIC TO SHOW HIDE WORKPLACE HAZARDS OR PPE SECTION FIELDS
  const modifiedContentNew = useMemo(() => {
    if (allContent?.fields?.hasItemListing) {
      return showWorkPlaceHazardsOrPPEContent(paraTextContent.content);
    } else {
      // Return the original content if there is no need for modification
      return paraTextContent;
    }
  }, [allContent, paraTextContent?.content]);

  function isItSelectedWorkPlaceHazardsOrPPE(ppeId = '') {
    const selectedWorkPlaceHazards =
      JSON.parse(localStorage.getItem('selected-workplace-hazard')) || [];
    const ppeFieldVal = getInputValues('69', formValData)?.value || [];
    const combineSelectedFields = [...ppeFieldVal, ...selectedWorkPlaceHazards];
    return combineSelectedFields?.length > 0
      ? combineSelectedFields?.some((selectedItem) => selectedItem?.id == ppeId)
      : false;
  }
  function showWorkPlaceHazardsOrPPEContent(contentArr = []) {
    const updatedContent = contentArr.filter(
      (ele) => {
        if (ele.nodeType === 'embedded-entry-block' && ele.data?.target?.sys?.id) {
          if (ele?.data?.target?.fields?.imageAsBase64) {
            return ele;
          } else {
            const isSelected = isItSelectedWorkPlaceHazardsOrPPE(ele.data?.target?.sys?.id);
            if (isSelected === true) {
              return ele;
            }
          }
        } else {
          return ele;
        }
      },
    );
    if (updatedContent.length > 0) {
      setModifiedContent({
        nodeType: 'document',
        data: {},
        content: updatedContent,
      });
    }
  }

  //Convert arrayString to string(To show first Aid String In PDF)
  const convertArrayToString = (inpuId, arrStr = []) => {
    const fieldVal = getInputValues(inpuId, formValData)?.value;
    let str = '';
    fieldVal?.forEach((ele, index) => {
      if (index === 0) {
        str += ele;
      } else if (index === fieldVal.length - 1) {
        str += ` and ${ele}`;
      } else {
        str += `, ${ele}`;
      }
    });
    return str;
  };

  const EmbeddedEntryBlockWithImage = ({ node, imageItems }) => {
    const linkedItem = imageItems?.find(
      (imageItem) => imageItem?.sys?.id === node?.data?.target?.sys?.id,
    );
    return (
      <div className="imageWithText">
        <div className="section-pointer-img--wrapper">
          {/* Showing Controlling Hazards and Overview Images */}
          <img className="image64" src={linkedItem?.fields?.imageAsBase64} alt="item" />
        </div>
        <div className="section-pointer-text-wrapper">
          <b>{linkedItem?.fields?.description}</b>
        </div>
      </div>
    );
  };
  const EmbeddedEntryBlockWithItemsWithDescription = ({ node, imageItems }) => {
    const description = node?.data?.target?.fields?.description;
    let chemicalImgLoopCount = 0;
    let imgStr = [];
    const filteredImgsContent = description?.content?.filter(item => item.nodeType === 'embedded-entry-block');
    if (node?.data?.target?.fields?.imagesBase64format) {
      imgStr = node?.data?.target?.fields?.imagesBase64format?.content[0]?.content[0]?.value?.split('BREAK')
    }

    const renderOptions = {
      renderNode: {
        paragraph: (node, children) => <p>{children}</p>,
        text: (node) => node.value,
        'unordered-list': (node, children) => <ul>{children}</ul>,
        'list-item': (node, children) => (
          <div style={{ display: 'flex' }}>
            <li>{children}</li>
          </div>
        ),
        'embedded-entry-block': (node, children) => {
          chemicalImgLoopCount++;
          let filteredImageItems = [];
          if (filteredImgsContent && filteredImgsContent?.length > 0) {
            const filteredImgsContentIds = filteredImgsContent?.map(item => item?.data?.target?.sys?.id);
            filteredImageItems = imageItems?.filter(item => filteredImgsContentIds.includes(item?.sys?.id));
          }
          return (
            <>
              {
                chemicalImgLoopCount === 1 &&
                (
                  <div className="group-images-container">
                    <div style={{ width: 'auto' }} className='sub-group-images-container'>
                      {
                        filteredImageItems?.map((chemicalImgs) => {
                          return (
                            <>
                              {/* Showing Chemical Hazards Images */}
                              <img
                                style={{ marginLeft: '10px' }}
                                src={chemicalImgs?.fields?.imageAsBase64}
                                alt={chemicalImgs?.fields?.description}
                                className='chemical-hazards-img'
                              />
                            </>
                          )
                        })
                      }
                    </div>
                  </div>
                )
              }
            </>
          );
        },
      },
    };
    return (
      <div key={node?.data?.target?.sys.id} className="imageWithDescription">
        <div className="section-pointer-img--wrapper">
          {node?.data?.target?.fields?.imagesBase64format &&
            // showing PPE images
            imgStr?.map((imgstring) => {
              return (
                <img
                  className="image64"
                  style={{ width: '50px' }}
                  src={imgstring}
                  alt="item"
                />
              )
            })
          }
        </div>
        <div className="description-section">
          <h3>
            <b>{node?.data?.target?.fields?.name}</b>
          </h3>
          <div className="discription-content-renderer">
            {documentToReactComponents(description, renderOptions)}
          </div>
        </div>
      </div>
    );
  };

  const renderNestedList = (content) => {
    if (!content || content?.length === 0) {
      return <></>;
    }

    return (
      <ul>
        {content?.map((item, index) => (
          <ListItemRenderer key={index} node={item} />
        ))}
      </ul>
    );
  };

  //TO SHOW NESTED LIST
  const ListItemRenderer = ({ node }) => {
    if (node?.content) {
      if (node?.content[1]?.content && node?.content[1].content?.length > 0) {
        return (
          <li>
            {node?.content[0]?.content[0]?.value}
            {renderNestedList(node?.content[1]?.content)}
          </li>
        );
      } else {
        return <li>{node?.content[0]?.content[0]?.value}</li>;
      }
    } else {
      return <></>;
    }
  };

  function ShowEntryContent(
    businessName,
    contentId,
    content,
    imageItems,
  ) {
    const replacements = {
      'COMPANY NAME': businessName,
      'INSERT COMMITMENT LOCATION':
        getInputValues('25', formValData)?.value ||
        getInputValues('27', formValData)?.value ||
        getInputValues('29', formValData)?.value ||
        getInputValues('31', formValData)?.value ||
        '',
      'Employer Name': getInputValues('18', formValData)?.value || 'Employer',
      'Supervisor Name': getInputValues('19', formValData)?.value || 'Supervisor',
      'Worker Name': getInputValues('20', formValData)?.value || 'Worker',
      'INSERT SHELTER IN PLACE LOCATION': getInputValues('33', formValData)?.value || '',
      'INSERT ASSEMBLY LOCATION': getInputValues('34', formValData)?.value || '',
      'INSERT_FIRST_AID_KIT_LOCATIONS': convertArrayToString('40', formValData) || '',
      'INSERT_EYE_WASH_STATION_LOCATION': getInputValues('72', formValData)?.value ? `${getInputValues('72', formValData)?.value}` : '',
      'INSERT_CHEMICAL_SHOWER_LOCATION': getInputValues('73', formValData)?.value ? `${getInputValues('73', formValData)?.value}` : '',
      'INSERT_NALOXONE_KIT_LOCATION': getInputValues('43', formValData)?.value ? `${getInputValues('43', formValData)?.value}` : '',
      // Add more replacements as needed
    };

    //Replaceing String Value with Contentful Text
    const renderText = (text) => {
      let updatedText = text;
      for (const [search, replace] of Object.entries(replacements)) {
        updatedText = updatedText.replaceAll(new RegExp(search, 'g'), replace);
      }
      return <span>{updatedText}</span>;
    };

    const options = {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: (node) => {
          return node?.data?.target?.fields?.name ? (
            <EmbeddedEntryBlockWithItemsWithDescription node={node} imageItems={imageItems} />
          ) : (
            <EmbeddedEntryBlockWithImage node={node} imageItems={imageItems} />
          );
        },
        [BLOCKS.LIST_ITEM]: (
          node,
          children,
        ) => <ListItemRenderer node={node}>{children}</ListItemRenderer>,
      },
      renderText: renderText,
    };
    return (
      <div className="content-container" id={contentId}>
        {(() => {
          if (content?.overRideContent !== undefined && content?.overRideContent !== null) {
            return <div dangerouslySetInnerHTML={{ __html: content.overRideContent }} />;
          } else {
            if (allContent?.fields?.hasItemListing) {
              return documentToReactComponents(modifiedContent, options);
            } else {
              return documentToReactComponents(content, options);
            }
          }
        })()}
      </div>
    );
  }

  return <>{ShowEntryContent(businessName, contentId, paraTextContent, imageItems)}</>;
};
export default EntryContentRenderer;
